<template>
  <section>
    <file-pond
      name="test"
      ref="pond"
      :server="{ process, revert, restore, load, fetch }"
      labelIdle="Drop a file here..."
      allowMultiple="true"
      allowRevert="false"
      acceptedFileTypes="image/bmp, image/jpeg, image/png, image/gif, text/csv, audio/mpeg, video/mpeg, application/pdf, application/rtf, text/plain, application/zip, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/msword"
      v-bind:files="uploadFiles"
      v-on:init="handleFilePondInit"
    />
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.css'
const FilePond = vueFilePond()
export default {
  name: 'chat-upload',
  components: {
    FilePond
  },
  data() {
    return {
      uploadFiles: [],
      apiUrl: '',
      imageUrl: null,
      firm: null,
      path: null
    }
  },
  mounted() {
    this.apiUrl = window.config ? window.config.apiUrl : ''
    this.init()
  },
  computed: {
    ...mapGetters('auth', ['profile', 'token']),
    ...mapGetters('chat', ['channelInfo'])
  },
  methods: {
    init() {
      let elements = document.getElementsByClassName('filepond--credits')
      if (elements) {
        elements[0].style['display'] = 'none'
      }
      this.firm = null
      this.path = null
      console.log('Channel Info', this.channelInfo)
      if (this.channelInfo) {
        let type = this.channelInfo.type.substring(0, 5)
        let elements = this.channelInfo.url.split('_')
        this.firm = elements[1]
        this.path = type === 'adhoc' ? `users/${elements[2]}` : elements[3]
        console.log('Type Info', {
          type: type,
          elements: elements,
          firm: this.firm,
          path: this.path
        })
      }
    },
    process(fieldName, file, metadata, load, error, progress, abort) {
      let $this = this
      if (this.firm) {
        // set data
        const formData = new FormData()
        formData.append('files', file, file.name)
        formData.append('firm', this.profile.firm)
        formData.append('path', `chats/${this.firm}/${this.path}`)
        // related to aborting the request
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        axios.interceptors.request.use(
          config => {
            config.headers['Authorization'] = 'Bearer ' + this.token
            return config
          },
          error => {
            return Promise.reject(error)
          }
        )
        // the request itself
        axios({
          method: 'post',
          url: `${this.apiUrl}/chat/uploadFile`,
          data: formData,
          cancelToken: source.token,
          onUploadProgress: e => {
            // updating progress indicator
            progress(e.lengthComputable, e.loaded, e.total)
          }
        })
          .then(response => {
            let data = {
              filename: file.name,
              url: response.data
            }
            load(file.name)
            $this.$emit('uploaded', data)
          })
          .catch(thrown => {
            if (axios.isCancel(thrown)) {
              console.log('Request canceled', thrown.message)
            } else {
              // handle error
            }
          })
        // Setup abort interface
        return {
          abort: () => {
            source.cancel('Operation canceled by the user.')
          }
        }
      } else {
        return null
      }
    },
    revert(uniqueFileId, load, error) {},
    load(uniqueFileId, load, error) {},
    fetch(url, load, error, progress, abort, headers) {},
    restore(uniqueFileId, load, error, progress, abort, headers) {},
    handleError(error) {
      console.log('Error', error)
    },
    handleFilePondInit: function() {}
  }
}
</script>
<style lang="scss" scoped>
.custom-logo {
  max-height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/elements/chat-upload.vue